export default __webpack_public_path__ + "static/media/truck2_white.709d29b5.svg";